// extracted by mini-css-extract-plugin
module.exports = {"createSortCard":"styles_createSortCard__2WX3u","createSortCardContent":"styles_createSortCardContent__2KIBN"};